import { useState } from 'react';

const useWalletCard = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return {
    isModalVisible,
    openModal: () => setIsModalVisible(true),
    closeModal: () => setIsModalVisible(false),
  };
};

export default useWalletCard;
